import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewInvoiceModal from "../../../../invoice/newmodal.component.jsx"
import Icon from "../../../icon/icon.component"

type OwnProps = {
    contactId? : string
    className? : string
}

const ReturnCreationButton = (props : OwnProps) => {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = (id?: string) => {
        setOpenModal(false)

        if (id) {
            window.location.href = `/returns/${id}/edit`
        }
    }

    return (
        <>
            {openModal && <NewInvoiceModal
                isReturn={true}
                onClose={handleCloseModal}
                contactId={props.contactId}
            />}
            <button onClick={handleOpenModal} className={props.className ? "btn " + props.className : "btn btn-primary"}>
                <Icon value={"plus-circle"} />
                <FormattedMessage
                    id="listing.search.return_add_btn"
                    defaultMessage="New return"
                />
            </button>
        </>
    )
}

export default ReturnCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/ReturnCreationButton.tsx